

























































import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { IUserDefinedInformationKey } from "../../../../../../../documaker/domain/format/objects";
import { IUserDefinitionSpecification } from "../../../../../../domain/editableFormat";

@Component
export default class UserDefinedInformationSelectDialog extends Mixins(DialogMixin) {
  selectedInformations: IUserDefinitionSpecification[] = [];
  selectingInformation: IUserDefinedInformationKey = null;
  selectingItem: string = "";
  selectingFile: string = "";
  isConfirmed: boolean = false;
  isItemSelected: boolean = false;

  async show(informations: IUserDefinitionSpecification[], selected: IUserDefinedInformationKey): Promise<IUserDefinedInformationKey> {
    return this.showModal(async () => {
    this.selectedInformations = informations;
    this.selectingInformation = ObjectUtility.copyDeeply(selected) as IUserDefinedInformationKey;
    if (!selected) {
      this.selectingFile = "";
      this.selectingItem = "";
    } else {
      this.selectingFile = this.selectingInformation.name;
      this.selectingItem = this.selectingInformation.column;
    }
    this.isConfirmed = false;
    this.isItemSelected = false;

    await this.waitHidden();
    return this.isConfirmed ? this.selectingInformation : null;
    });
  }

  getSelectedItems(value: string): string[] {
    const selectedItems = Enumerable.from(this.selectedInformations)
        .firstOrDefault(s => s.name === value, null);
    return !selectedItems ? [] : selectedItems.columns;
  }

  setSelectingInformation(): void {
    this.selectingInformation.name = this.selectingFile;
    this.selectingInformation.column = this.selectingItem;
    this.isItemSelected = true;
  }
  
  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
